// private data

/*************************************
 State
 **/
const state = {
	popupTakeResa: false,
	popupCreateRoom: false,
	popupManageServices: false,
	popupTableSelected: false,
	screenServices: false,
	screenEvents: false,
	screenDiscount: false,
	screenlockedServices: false,
	screenlockedRooms: false,
	screenIntegration: false,
	screenInfos: false,
	screenReviews: false,
	screenClientsBook: false,
	screenCashList: false,
	screenResaList: false,
	screenStats: false,
	loadingRightSide: false,
	updateAppAlerte: false,
	dialogEditClient: false,
	dialogCancelResa: false,
	dialogEditCash: false,
	dialogEditEvent: false,
	dialogEditDiscount: false,
	dialogError: false,
	dialogPayement: false,
};

/*************************************
 Getters
 **/
const getters = {
	isVisiblePopupTakeResa: (state) => {
		return state.popupTakeResa;
	},
	isVisiblePopupCreateRoom: (state) => {
		return state.popupCreateRoom;
	},
	isVisiblePopupManageServices: (state) => {
		return state.popupManageServices;
	},
	isVisiblePopupTableSelected: (state) => {
		return state.popupTableSelected;
	},
	isVisibleScreenServices: (state) => {
		return state.screenServices;
	},
	isVisibleScreenEvents: (state) => {
		return state.screenEvents;
	},
	isVisibleScreenDiscount: (state) => {
		return state.screenDiscount;
	},
	isVisibleScreenLockedServices: (state) => {
		return state.screenlockedServices;
	},
	isVisibleScreenLockedRooms: (state) => {
		return state.screenlockedRooms;
	},
	isVisibleScreenIntegration: (state) => {
		return state.screenIntegration;
	},
	isVisibleScreenInfos: (state) => {
		return state.screenInfos;
	},
	isVisibleScreenReviews: (state) => {
		return state.screenReviews;
	},
	isVisibleScreenClientBook: (state) => {
		return state.screenClientsBook;
	},
	isVisibleScreenCashList: (state) => {
		return state.screenCashList;
	},
	isVisibleScreenStats: (state) => {
		return state.screenStats;
	},
	isVisibleScreenResaList: (state) => {
		return state.screenResaList;
	},
	isRightSideLoading: (state) => {
		return state.loadingRightSide;
	},
	isVisibleUpdateAppAlerte: (state) => {
		return state.updateAppAlerte;
	},
	isVisibleDialogEditClient: (state) => {
		return state.dialogEditClient;
	},
	isVisibleDialogCancelResa: (state) => {
		return state.dialogCancelResa;
	},
	isVisibleDialogEditCash: (state) => {
		return state.dialogEditCash;
	},
	isVisibleDialogEditEvent: (state) => {
		return state.dialogEditEvent;
	},
	isVisibleDialogEditDiscount: (state) => {
		return state.dialogEditDiscount;
	},
	isVisibleDialogError: (state) => {
		return state.dialogError;
	},
	isVisibleDialogPayement: (state) => {
		return state.dialogPayement;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	setPopupTakeResa(state, val) {
		state.popupTakeResa = val;
	},
	setPopupCreateRoom(state, val) {
		state.popupCreateRoom = val;
	},
	setPopupManageServices(state, val) {
		state.popupManageServices = val;
	},
	setPopupTableSelected(state, val) {
		if (state.popupTakeResa) state.popupTableSelected = false;
		else state.popupTableSelected = val;
	},
	setScreenServices(state, val) {
		state.screenServices = val;
	},
	setScreenEvents(state, val) {
		state.screenEvents = val;
	},
	setScreenDiscount(state, val) {
		state.screenDiscount = val;
	},
	setScreenLockedServices(state, val) {
		state.screenlockedServices = val;
	},
	setScreenLockedRooms(state, val) {
		state.screenlockedRooms = val;
	},
	setScreenIntegration(state, val) {
		state.screenIntegration = val;
	},
	setScreenInfos(state, val) {
		state.screenInfos = val;
	},
	setScreenReviews(state, val) {
		state.screenReviews = val;
	},
	setScreenClientsBook(state, val) {
		state.screenClientsBook = val;
	},
	setScreenCashList(state, val) {
		state.screenCashList = val;
	},
	setScreenStats(state, val) {
		state.screenStats = val;
	},
	setScreenResaList(state, val) {
		state.screenResaList = val;
	},
	setRightSideLoading(state, val) {
		state.loadingRightSide = val;
	},
	setUpdateAppAlerte(state, val) {
		state.updateAppAlerte = val;
	},
	setDialogEditClient(state, val) {
		state.dialogEditClient = val;
	},
	setDialogCancelResa(state, val) {
		state.dialogCancelResa = val;
	},
	setDialogEditCash(state, val) {
		state.dialogEditCash = val;
	},
	setDialogEditEvent(state, val) {
		state.dialogEditEvent = val;
	},
	setDialogEditDiscount(state, val) {
		state.dialogEditDiscount = val;
	},
	setDialogError(state, val) {
		state.dialogError = val;
	},
	setDialogPayement(state, val) {
		state.dialogPayement = val;
	},
	resetStore(state) {
		state.popupTakeResa = false;
		state.popupCreateRoom = false;
		state.popupManageServices = false;
		state.popupTableSelected = false;
		state.screenServices = false;
		state.screenEvents = false;
		state.screenDiscount = false;
		state.screenlockedServices = false;
		state.screenlockedRooms = false;
		state.screenIntegration = false;
		state.screenInfos = false;
		state.screenReviews = false;
		state.screenClientsBook = false;
		state.screenCashList = false;
		state.screenStats = false;
		state.screenResaList = false;
		state.loadingRightSide = false;
		state.updateAppAlerte = false;
		state.dialogEditClient = false;
		state.dialogCancelResa = false;
		state.dialogEditCash = false;
		state.dialogEditEvent = false;
		state.dialogEditDiscount = false;
		state.dialogError = false;
		state.dialogPayement = false;
	},
};

/*************************************
 Action
 **/
const actions = {
	showHidePopupTakeResa: function ({ state, rootState, commit, dispatch }) {
		if (state.popupTakeResa) commit("setPopupTakeResa", false);
		else {
			dispatch("hideAll");
			commit("setPopupTakeResa", true);
		}
	},
	showHidePopupCreateRoom: function ({ state, rootState, commit, dispatch }) {
		if (state.popupCreateRoom) commit("setPopupCreateRoom", false);
		else {
			dispatch("hideAll");
			commit("setPopupCreateRoom", true);
		}
	},
	showHidePopupManageServices: function ({ state, rootState, commit, dispatch }) {
		if (state.popupManageServices) commit("setPopupManageServices", false);
		else {
			dispatch("hideAll");
			commit("setPopupManageServices", true);
		}
	},
	showHidePopupTableSelected: function ({ state, rootState, commit, dispatch }) {
		if (state.popupTableSelected) commit("setPopupTableSelected", false);
		else {
			dispatch("hideAll");
			commit("setPopupTableSelected", true);
		}
	},
	showHideScreenServices: function ({ state, rootState, commit, dispatch }) {
		if (state.screenServices) commit("setScreenServices", false);
		else {
			dispatch("hideAll");
			commit("setScreenServices", true);
		}
	},
	showHideScreenEvents: function ({ state, rootState, commit, dispatch }) {
		if (state.screenEvents) commit("setScreenEvents", false);
		else {
			dispatch("hideAll");
			commit("setScreenEvents", true);
		}
	},
	showHideScreenDiscount: function ({ state, rootState, commit, dispatch }) {
		if (state.screenDiscount) commit("setScreenDiscount", false);
		else {
			dispatch("hideAll");
			commit("setScreenDiscount", true);
		}
	},
	showHideLockedService: function ({ state, rootState, commit, dispatch }) {
		if (state.screenlockedServices) commit("setScreenLockedServices", false);
		else {
			dispatch("hideAll");
			commit("setScreenLockedServices", true);
		}
	},
	showHideLockedRoom: function ({ state, rootState, commit, dispatch }) {
		if (state.screenlockedRooms) commit("setScreenLockedRooms", false);
		else {
			dispatch("hideAll");
			commit("setScreenLockedRooms", true);
		}
	},
	showHideScreenIntegration: function ({ state, rootState, commit, dispatch }) {
		if (state.screenIntegration) commit("setScreenIntegration", false);
		else {
			dispatch("hideAll");
			commit("setScreenIntegration", true);
		}
	},
	showHideScreenInfos: function ({ state, rootState, commit, dispatch }) {
		if (state.screenInfos) commit("setScreenInfos", false);
		else {
			dispatch("hideAll");
			commit("setScreenInfos", true);
		}
	},
	showHideScreenReviews: function ({ state, rootState, commit, dispatch }) {
		if (state.screenReviews) commit("setScreenReviews", false);
		else {
			dispatch("hideAll");
			commit("setScreenReviews", true);
		}
	},
	showHideScreenClientsBook: function ({ state, rootState, commit, dispatch }) {
		if (state.screenClientsBook) commit("setScreenClientsBook", false);
		else {
			dispatch("hideAll");
			commit("setScreenClientsBook", true);
		}
	},
	showHideScreenCashList: function ({ state, rootState, commit, dispatch }) {
		if (state.screenCashList) commit("setScreenCashList", false);
		else {
			dispatch("hideAll");
			commit("setScreenCashList", true);
		}
	},
	showHideScreenStats: function ({ state, rootState, commit, dispatch }) {
		if (state.screenStats) commit("setScreenStats", false);
		else {
			dispatch("hideAll");
			commit("setScreenStats", true);
		}
	},
	showHideScreenResaList: function ({ state, rootState, commit, dispatch }) {
		if (state.screenResaList) commit("setScreenResaList", false);
		else {
			dispatch("hideAll");
			commit("setScreenResaList", true);
		}
	},
	hideAll: function ({ state, commit }, payload = false) {
		commit("setScreenClientsBook", false);
		commit("setScreenCashList", false);
		commit("setScreenStats", false);
		commit("setScreenResaList", false);
		commit("setScreenIntegration", false);
		commit("setScreenInfos", false);
		commit("setScreenReviews", false);
		commit("setScreenServices", false);
		commit("setScreenEvents", false);
		commit("setScreenDiscount", false);
		commit("setScreenLockedServices", false);
		commit("setScreenLockedRooms", false);
		commit("setPopupTableSelected", false);
		commit("setPopupManageServices", false);
		commit("setPopupCreateRoom", false);
		if (!payload) commit("setPopupTakeResa", false);
		commit("setUpdateAppAlerte", false);
		commit("setDialogEditClient", false);
		commit("setDialogCancelResa", false);
		commit("setDialogEditCash", false);
		commit("setDialogEditEvent", false);
		commit("setDialogEditDiscount", false);
		commit("setDialogError", false);
		commit("setDialogPayement", false);
		commit("newReservations/setModSwitchTable", false, { root: true });
	},
};

/*************************************
 Helpers
 **/

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
